import { jsx, css } from '@emotion/react';
import { define, ui } from '@owenscorning/pcb.alpha';

import Renderer from '../../../../OC/PageBuilder/VidaWoolComparisonTable.jsx';

export default define`VidaWool Comparison Table`('0.0.1')({
  thumbnail: ui`Modules/Page/Thumbnails/VidaWoolComparisonTable`,
  category: ui`Modules/Categories/Page/Prebuilt`,
  view: ({ value }) => <Renderer {...value} />,
  edit: {},
});
